var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { EarningCategory, EarningContainer, EarningIconContainer, EarningReward, EarningTextContainer, EarningValue, EarningsContainer, EarningsLastStatement } from './subcomponents';
import theme from '../../theme';
import sortEarnings from '../../../helpers/sortEarnings';
var DualCardEarnings = function (_a) {
    var className = _a.className, earningsIcons = _a.earningsIcons, rewardsBalance = _a.rewardsBalance;
    var t = useTranslation().t;
    var sortedEarnings = useMemo(function () { return sortEarnings({ rewardsBalance: rewardsBalance, earningsIcons: earningsIcons }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rewardsBalance === null || rewardsBalance === void 0 ? void 0 : rewardsBalance.rewardDetails, earningsIcons]);
    return (_jsxs(_Fragment, { children: [_jsx(EarningsLastStatement, __assign({ className: className }, { children: t('jCrewEarnings.earningsFromLastStatement') })), _jsx(EarningsContainer, { children: sortedEarnings === null || sortedEarnings === void 0 ? void 0 : sortedEarnings.map(function (earning) {
                    var _a = earning.displayName.split(':'), earningCategory = _a[0], earningReward = _a[1];
                    var currentEarning = earningsIcons[earning.Id];
                    return (_jsxs(EarningContainer, { children: [_jsxs(EarningIconContainer, { children: [(currentEarning === null || currentEarning === void 0 ? void 0 : currentEarning.icon) && (_jsx(FontAwesomeIcon, { width: 32, color: theme.cyanBlue, fontSize: 25, icon: currentEarning.icon })), _jsx(EarningTextContainer, { children: _jsxs(EarningCategory, __assign({ "$earningId": earning.Id }, { children: [earningCategory, earningReward && (_jsxs(_Fragment, { children: [":", _jsx(EarningReward, __assign({ as: "span" }, { children: earningReward }))] }))] })) })] }), _jsx(EarningValue, __assign({ "$earningId": earning.Id }, { children: earning.value }))] }, earning.Id));
                }) })] }));
};
export default DualCardEarnings;
